<template>
  <dashboard>
    <template v-slot:content>
      <loading v-show="!loading" />
      <section>
        <b-container fluid>
          <div class="header-elements align-items-center">
            <b-row class="mt-2">
              <b-col lg="12" md="12">
                <b-row class>
                  <b-col lg="5" md="7">
                    <h5 class="mt-2" v-text="Title" />
                  </b-col>
                  <b-col lg="4" md="4" class="p-0">
                    <b-input-group>
                      <b-input-group-text slot="prepend" class="search-icon">
                        <font-awesome-icon :icon="['fas', 'search']" />
                      </b-input-group-text>
                      <b-form-input
                        v-model="search"
                        ref="search"
                        placeholder="Enter or Scan Barcode"
                        class="search"
                        autocomplete="off"
                        v-shortkey.focus="['ctrl', 's']"
                        @keyup.enter="addProduct"
                        :disabled="stockPointId == null"
                        id="prod-search-audit"
                      />
                    </b-input-group>
                  </b-col>
                  <b-col lg="3" md="3" class="pl-2">
                    <b-row>
                      <b-col lg="6" md="6" class="pr-0">
                        <b-button
                          block
                          variant="outline-primary"
                          @click="back"
                          id="audit-back"
                          >Back</b-button
                        >
                      </b-col>
                      <b-col lg="6" md="6" class="pl-1">
                        <b-button
                          variant="primary"
                          class="w-100"
                          v-on:click="isContentShow = !isContentShow"
                          :disabled="
                            stockCounts.length == 0 || description == ''
                          "
                          @click="saveCount('btn')"
                          id="save-count"
                          >Save Count</b-button
                        >
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-container>
      </section>

      <section>
        <b-container fluid>
          <div class="card mt-2 mb-2 p-3">
            <b-row>
              <b-col md="4">
                <label>Stockpoint</label>
                <b-form-select
                  v-model.number="stockPointId"
                  size="sm"
                  @change="getStockPointProducts"
                  :disabled="stockCounts.length > 0"
                  id="select-stockpoint"
                >
                  <option value="null" disabled>Select Stockpoint</option>
                  <option
                    v-for="val in stockPointList"
                    :value="val.id"
                    v-text="val.name"
                    :key="val.id"
                    :id="val.name"
                  ></option>
                </b-form-select>
              </b-col>
              <b-col md="8">
                <label id="count-desc-label">
                  Count description
                  <span style="color: #ff6666;">*</span>
                </label>
                <b-form-input
                  type="text"
                  autocomplete="off"
                  placeholder="Add a description of the count"
                  id="count-desc-input"
                  v-model="description"
                />
              </b-col>
            </b-row>
          </div>
          <div class="card mt-2">
            <div class="customer-info box-shadow">
              <div class="table-dark-bg box-shadow px-0 sale">
                <div style="height:calc(100vh - 205px)" class="sale-summary">
                  <div v-if="stockCounts.length != 0">
                    <b-table
                      striped
                      :fields="fields"
                      :items="stockCounts"
                      class="table cart-table table-dark table-large px-5"
                      style="line-height: 25px;"
                    >
                      <template v-slot:cell(index)="data">{{
                        pagination.page * pagination.limit -
                          pagination.limit +
                          data.index +
                          1
                      }}</template>
                      <!-- <template v-slot:cell(unit_mrp)="data">
                        ₹
                        {{ parseFloat(data.item.unit_mrp).toFixed(2) }}
                      </template>-->
                      <template v-slot:cell(qty)="data">
                        <b-input-group>
                          <template v-slot:append>
                            <b-input-group-text style="border-left:0">
                              <font-awesome-icon
                                size="xs"
                                :icon="['fas', 'pencil-alt']"
                                v-if="data.index + 1 == focusInput"
                              />
                            </b-input-group-text>
                          </template>
                          <b-form-input
                            type="number"
                            v-model="data.item.qty"
                            size="sm"
                            style="border-right:0"
                            @focus="focusInput = data.index + 1"
                            :id="data.index + '-input'"
                            @blur="updateQty(data.item)"
                          ></b-form-input>
                        </b-input-group>
                      </template>
                      <template v-slot:cell(remove)="data">
                        <font-awesome-icon
                          :icon="['fas', 'times']"
                          style="cursor: pointer;"
                          @click="removeProduct(data.item)"
                        />
                      </template>
                    </b-table>
                    <!-- <p
                      v-if="stockCounts == 0"
                      style="height: 70vh;"
                      class="text-muted d-flex align-items-center justify-content-center"
                    >
                      No counts completed yet. Tap on ‘Add New Count’ to start a
                      new count.
                    </p>-->
                  </div>
                  <div
                    v-else
                    class="d-flex align-items-center justify-content-center"
                    style="height: 70vh;"
                  >
                    <p class="text-muted">
                      Start adding products by scanning/entering their barcodes.
                    </p>
                  </div>
                </div>
              </div>

              <!--<b-row class="py-1 px-2 activites-bar">
                  <b-col>#</b-col>
                  <b-col>Barcode</b-col>
                  <b-col md="3">Product name</b-col>
                  <b-col>Department</b-col>
                  <b-col md="2">Category</b-col>
                  <b-col>Brand</b-col>
                  <b-col>Unit MRP</b-col>
                  <b-col>Quantity</b-col>
                  <b-col></b-col>
                </b-row>
                <div class="customer-data">
                  <b-row v-if="stockCounts==''" class="text-muted d-flex align-items-center w-100 h-100 justify-content-center">Start adding products by scanning/entering their barcodes.</b-row>
                  <b-row
                    class="py-4 px-4"
                    v-for="info in stockCounts"
                    :key="info.id"
                  >
                    <b-col>{{index + 1}}</b-col>
                    <b-col >{{info.barcode}}</b-col>
                    <b-col md="3">{{info.Product}}</b-col>
                    <b-col >{{info.Department}}</b-col>
                    <b-col md="2">{{info.Category}}</b-col>
                    <b-col >{{info.Brand}}</b-col>
                    <b-col >{{info.MRP}}</b-col>
                    <b-col >{{info.qty}}</b-col>
                    <b-col >edit</b-col>
              </b-row>-->
            </div>
          </div>
        </b-container>
        <b-pagination
          class="mt-1 mr-2"
          :class="[
            checkEmpty(pagination.total) || checkEmpty(stockPointId)
              ? 'opacity'
              : '',
          ]"
          v-model="pagination.page"
          :total-rows="pagination.total"
          :per-page="pagination.limit"
          pills
          @change="pageNumber"
          align="right"
        />
      </section>
      <progress-modal
        :open="showProgress.open"
        :current="showProgress.current"
        :total="showProgress.max"
        :title="showProgress.title"
        @close-progress-modal="
          showProgress = {
            open: false,
            max: 100,
            current: 0,
            title: 'Fetching Products',
          }
        "
      />
    </template>
  </dashboard>
</template>

<script>
import Dashboard from "../views/Dashboard";
import Loading from "../components/Loading";
import axios from "axios";
import { mapState } from "vuex";
import db from "../database";
import _ from "lodash";
import ProgressModal from "../components/ProgressModal";

export default {
  name: "stock-count",
  components: {
    Dashboard,
    Loading,
    ProgressModal,
  },
  beforeRouteLeave(to, from, next) {
    this.$loading = true;
    let postData = {
      url: "/audit/reconsile-checker",
      audit_plan_id: this.state.stock.plan_details.audit_plan_id,
      is_reconciliation: 0,
    };
    let data = Object.assign(postData, this.vendorDetails);
    axios.post(data.url, data).then((res) => {
      next();
      this.$router.push("/stock-count-audit");
    });
  },
  mounted() {
    db.stock.clear();
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    vendorDetails() {
      return this.$store.getters["sessions/getVendorDetails"];
    },
    stockPointList() {
      let list = this.state.stock.plan_details.stockpoint_list.filter(
        (item) => {
          if (this.Title == "Update Count") {
            return item.id == this.state.stock.group_id;
          } else {
            return item.is_used == false;
          }
        }
      );
      return list;
    },
  },
  async created() {
    let count = 0;
    count = await db.stock.count();
    if (this.state.stock.group_id != 0) {
      this.stockPointId = this.state.stock.group_id;
      this.Title = "Update Count";
      if (count == 0) {
        this.editProducts();
      } else {
        this.pagination.page = 1;
        this.paginate();
      }
    }
  },
  data() {
    return {
      Title: "New Count",
      isContentShow: false,
      loading: true,
      stockPointId: null,
      isHidden: false,
      focusInput: 0,
      description: "",
      search: "",
      page: 1,
      showProgress: {
        open: false,
        max: 100,
        current: 0,
        title: "Fetching Products",
      },
      fields: [
        {
          key: "index",
          label: "#",
          class: "w-2 text-center",
        },
        {
          key: "barcode",
          label: "Barcode",
          class: "w-10",
        },
        {
          key: "name",
          label: "Product name",
          class: "w-30",
        },
        {
          key: "department",
          label: "Department",
          class: "w-15",
        },

        {
          key: "category",
          label: "Category",
          class: "w-15",
        },

        {
          key: "brand",
          label: "Brand",
          class: "w-15",
        },
        // {
        //   key: "unit_mrp",
        //   label: "Unit MRP",
        //   class: "w-10",
        // },
        {
          key: "qty",
          label: "Quantity",
          class: "w-10",
        },
        {
          key: "remove",
          label: "",
          class: "w-10 text-center",
        },
      ],
      stockCounts: [],
      pagination: {
        limit: 100,
        page: 1,
        total: 0,
      },
      saveCountBatch: {
        id: "",
        tBatch: 0,
        cBatch: 0,
        tProd: 0,
        rProd: 0,
        limit: 400,
      },
    };
  },
  methods: {
    back() {
      db.stock.clear();
      this.$router.push("/stock-count-audit");
      // this.showProgress.open = true;
    },
    editProducts() {
      this.$loading = true;
      this.showProgress.open = true;
      let postData = {
        stock_point_id: this.stockPointId,
        audit_plan_id: this.state.stock.plan_details.audit_plan_id,
        page: this.page,
        url: "/audit/get-stockpoint-products",
      };
      let data = Object.assign(postData, this.vendorDetails);
      axios
        .post(data.url, data)
        .then(async (response) => {
          // this.stockCounts = response.data.data;
          // this.stockCounts = response.data.data.filter(item => {
          //   return parseFloat(item.qty) != 0;
          // });
          this.description = response.data.description.description;
          await db.stock.bulkPut(response.data.data).then(async () => {
            this.pagination.page = 1;
            this.paginate();
          });
          if (this.page == response.data.last_page) {
            this.showProgress.open = false;
            this.$loading = false;
          } else {
            this.showProgress.max = response.data.last_page;
            this.showProgress.current = this.page;
            this.page += 1;
            this.editProducts();
          }
        })
        .catch(() => {
          this.showProgress.open = false;
          this.$loading = false;
        });
    },
    async saveCount(src) {
      let productList = [];
      if (src == "btn") {
        this.$loading = true;
        this.saveCountBatch.tProd = await db.stock
          .where(["stock_point_id+v_id"])
          .equals([this.stockPointId, parseInt(this.state.sessions.user.v_id)])
          .and((filter) => filter.is_scan)
          .count();
        this.saveCountBatch.rProd = this.saveCountBatch.tProd;
      } else {
        let offset = this.saveCountBatch.limit * this.saveCountBatch.cBatch;
        await db.stock
          .where(["stock_point_id+v_id"])
          .equals([this.stockPointId, parseInt(this.state.sessions.user.v_id)])
          .and((filter) => filter.is_scan)
          .offset(offset)
          .limit(this.saveCountBatch.limit)
          .each((item) => {
            delete item.v_id;
            delete item.brand;
            delete item.category;
            delete item.department;
            delete item.unit_mrp;
            delete item.id;
            delete item.name;
            delete item.is_scan;
            delete item.stock_point_id;
            delete item.timestamp;
            if (item.batch_no == "") {
              delete item.batch_no;
            }
            if (item.serial_no == "") {
              delete item.serial_no;
            }
            productList.push(item);
          });
      }

      let stockpointlist = this.state.stock.plan_details.stockpoint_list.filter(
        (item) => {
          if (item.id == this.stockPointId) {
            item.is_used = true;
          }
          return item;
        }
      );

      let postData = {
        url: "/audit/save-count",
        product_list: JSON.stringify(productList),
        stock_point_id: this.stockPointId,
        audit_plan_id: this.state.stock.plan_details.audit_plan_id,
        audit_allocation_code: this.state.stock.plan_details
          .audit_plan_allocation_code,
        description: this.description,
      };

      if (!this.checkEmpty(this.saveCountBatch.id)) {
        postData.id = this.saveCountBatch.id;
        // this.saveCountBatch.rProd =
        // this.saveCountBatch.rProd - productList.length;
        postData.product_count = this.saveCountBatch.rProd;
      }
      let data = Object.assign(postData, this.vendorDetails);
      axios
        .post(data.url, data)
        .then((res) => {
          if (res.data.status == "created") {
            this.saveCountBatch.id = res.data.data.id;
            this.saveCountBatch.tBatch = Math.ceil(
              this.saveCountBatch.tProd / this.saveCountBatch.limit
            );
            // this.saveCountBatch.cBatch = Math.ceil(
            //   this.saveCountBatch.tProd / 1
            // );
            this.showProgress = {
              open: true,
              max: this.saveCountBatch.tBatch,
              current: 0,
              title: "Saving Products",
            };
            this.saveCount("func");
          } else if (res.data.status == "continue") {
            this.saveCountBatch.cBatch = this.saveCountBatch.cBatch + 1;
            this.showProgress.current = this.saveCountBatch.cBatch;
            this.saveCountBatch.rProd =
              this.saveCountBatch.rProd - res.data.remaining;
            this.saveCount("func");
          } else if (res.data.status == "success") {
            this.showProgress = {
              open: false,
              max: 100,
              current: 0,
              title: "Fetching Products",
            };
            this.$store.commit("stock/updateStockPointList", stockpointlist);
            db.stock.clear();
            this.$router.push("/stock-count-audit");
            this.$loading = false;
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    getStockPointProducts() {
      this.$loading = true;
      let check = false;
      db.transaction("rw", db.stock, async () => {
        await db.stock
          .where("stock_point_id")
          .equals(this.stockPointId)
          .first((item) => {
            if (item != undefined) {
              check = true;
            }
          });
      })
        .then(async () => {
          if (!check) {
            this.showProgress.open = true;
            this.page = 1;
            this.getProducts();
          } else {
            this.paginate();
            this.$loading = false;
          }
        })
        .catch(() => {
          this.$loading = false;
        });
    },
    async getProducts() {
      let postData = {
        stock_point_id: this.stockPointId,
        audit_plan_id: this.state.stock.plan_details.audit_plan_id,
        page: this.page,
        url: "/audit/get-stockpoint-products",
      };
      let data = Object.assign(postData, this.vendorDetails);
      await axios
        .post(data.url, data)
        .then(async (response) => {
          if (
            (response.data.data == undefined ||
              response.data.data.length == 0) &&
            this.page == 1
          ) {
            let alertData = {
              message: "Products not found in this stockpoint.",
              type: "danger",
            };
            this.showProgress.open = false;
            this.$showAlert = true;
            this.$store.commit("notifications/showAlert", alertData);
            this.$loading = false;
          } else {
            this.showProgress.max = response.data.last_page;
            this.showProgress.current = this.page;
            await db.stock.bulkPut(response.data.data);
            if (this.page == parseInt(response.data.last_page)) {
              this.showProgress.open = false;
              this.$loading = false;
              this.paginate();
            } else {
              this.page += 1;
              this.getProducts();
            }
          }
        })
        .catch(() => {
          this.showProgress.open = false;
          this.$loading = false;
        });
    },
    async addProduct() {
      let existsItem = {};
      await db.stock
        .orderBy("id")
        .and((filter) => {
          return (
            filter.barcode == this.search &&
            filter.stock_point_id == this.stockPointId &&
            filter.is_scan
          );
        })
        .first((item) => {
          existsItem = item;
        });
      if (!this.checkEmpty(existsItem)) {
        existsItem.qty = parseFloat(existsItem.qty) + 1;
        let update = existsItem.qty;
        this.search = "";
        db.stock.update(existsItem.id, {
          qty: update,
          timestamp: new Date().getTime(),
        });

        return this.paginate();
      }
      // let existsItem = this.stockCounts.filter((item) => {
      //   if (
      //     item.barcode == this.search &&
      //     item.stock_point_id == this.stockPointId
      //   ) {
      //     item.qty += 1;
      //     let update = item.qty;
      //     this.search = "";
      //     db.stock.update(item.id, {
      //       qty: update,
      //     });
      //     return item;
      //   }
      // });

      if (this.checkEmpty(existsItem)) {
        db.transaction("rw", db.stock, async () => {
          await db.stock
            .where(["stock_point_id+v_id+barcode"])
            .equals([
              this.stockPointId,
              parseInt(this.state.sessions.user.v_id),
              this.search.toUpperCase(),
            ])
            .first((item) => {
              if (item != undefined) {
                if (item.qty == 0) {
                  item.qty = 1;
                  db.stock.update(item.id, {
                    qty: 1,
                    is_scan: true,
                    timestamp: new Date().getTime(),
                  });
                }
                // this.stockCounts.unshift(item);
                this.search = "";
                this.paginate();
              } else if (item == undefined) {
                this.search = "";
                let alertData = {
                  message: "Product not found.",
                  type: "danger",
                };
                this.$showAlert = true;
                this.$store.commit("notifications/showAlert", alertData);
              }
            });
        });
      }
    },
    removeProduct(data) {
      var index = this.stockCounts.indexOf(data);
      if (index !== -1) {
        this.stockCounts.splice(index, 1);
      }
      db.stock.update(data.id, {
        qty: 0,
        is_scan: false,
      });
      this.$nextTick(() => {
        this.$refs["search"].focus();
      });
      this.paginate();
    },
    updateQty(data) {
      this.focusInput = 0;
      let temp = 1;
      if (!this.checkEmpty(data.qty)) temp = data.qty;
      else data.qty = 1;

      db.stock.update(data.id, {
        qty: parseFloat(temp),
      });
    },
    pageNumber(page) {
      this.pagination.page = page;
      this.paginate();
    },
    async paginate() {
      let offset = 0;
      if (this.pagination.page > 1)
        offset =
          this.pagination.limit * this.pagination.page - this.pagination.limit;

      this.pagination.total = await db.stock
        .where("[stock_point_id+v_id]")
        .equals([this.stockPointId, parseInt(this.state.sessions.user.v_id)])
        .and((filter) => {
          return parseFloat(filter.qty) != 0 && filter.is_scan;
        })
        .count();

      this.stockCounts = await db.stock
        .orderBy("timestamp")
        .and((filter) => {
          return (
            filter.stock_point_id == this.stockPointId &&
            filter.v_id == parseInt(this.state.sessions.user.v_id) &&
            parseFloat(filter.qty) != 0 &&
            filter.is_scan
          );
        })
        .offset(offset)
        .limit(this.pagination.limit)
        .reverse()
        .toArray();
    },
  },
};
</script>
<style lang="scss" scoped>
.light-grey {
  color: #e0e0e0;
}

.theme-light {
  .customer-info a {
    color: $body-color;
  }
}
.theme-dark {
  .light-grey {
    color: #404040;
  }
  .customer-info {
    color: $white-color;
    background-color: #202020 !important;
    a {
      color: $white-color;
    }
    .row {
      border-bottom: 1px solid #404040;
    }
  }
}
.customer-info {
  .row {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    .badge {
      font-weight: normal;
      background: $light-grey;
      color: $body-color;
      width: 13 0px;
      @include text-overflow();
    }
  }
}

.customer-data {
  height: calc(100vh - 90px);
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: -15px;
  margin-right: -15px;
  @include custom-scrollbar();
}
</style>
